module.exports = __webpack_public_path__ + "static/img/bird10.7ea118f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bird10.png
// module id = 6LJ1
// module chunks = 1